<script>
  import { Link } from 'svelte-navigator';
  import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from '@sveltestrap/sveltestrap';

  import { classnames } from '@client/utils/classnames';

  /**
   * @typedef {[label: string, url?: string]} Path
   * Represents a single navigation item tuple, containing a required label (string)
   * and an optional URL (string).
   */

  /**
   * Additional CSS class name for the component
   * @type {string}
   * @default ''
   */
  let className = '';
  export { className as class };

  /**
   * Holds the list of navigation paths used in the application.
   * Each element in the array is a `Path` tuple.
   * @type {Path[]}
   */
  export let paths = [];

  /**
   * The title string.
   * @type {string}
   */
  export let title = '';

  $: classes = classnames('page-header', className);
</script>

<div class={classes}>
  <Container fluid>
    {#if paths.length}
      <Row>
        <Col>
          <Breadcrumb>
            {#each paths as [label, path]}
              <BreadcrumbItem>
                {#if path}
                  <Link to={path}>
                    {label}
                  </Link>
                {:else}
                  {label}
                {/if}
              </BreadcrumbItem>
            {/each}
          </Breadcrumb>
        </Col>
      </Row>
    {/if}
    <Row class="align-items-center mx-100">
      <Col xs={$$slots.default ? 8 : 12} sm={$$slots.default ? 6 : undefined} md={$$slots.default ? 5 : undefined}>
        <slot name="title">
          <h1 class="page-title">{title}</h1>
        </slot>
      </Col>
      {#if $$slots.default}
        <Col xs="4" sm="6" md="7" class="text-right">
          <slot />
        </Col>
      {/if}
    </Row>
  </Container>
</div>
